import { useEffect, useMemo, useRef, useState } from "react";
import styles from "../detalhe.styles.module.css";
import {
  acaoLimparContas,
  acaoSelecionarContasResultado,
  acaoSelecionarTodas,
  alternarContaSelecao,
  isContaMarcada,
  textoTriggerContas,
} from "../utils/contasMultiSelect.util";

export default function FiltroContasMultiSelect({
  opcoes = [],
  selecionadas = [],
  onChange,
}) {
  const [aberto, setAberto] = useState(false);
  const [busca, setBusca] = useState("");
  const wrapRef = useRef(null);

  const opcoesFiltradas = useMemo(() => {
    const q = busca.trim().toLowerCase();
    if (!q) return opcoes;
    return opcoes.filter(
      (c) =>
        String(c.label).toLowerCase().includes(q) ||
        String(c.codigo).toLowerCase().includes(q)
    );
  }, [opcoes, busca]);

  const textoTrigger = useMemo(
    () => textoTriggerContas(selecionadas, opcoes),
    [selecionadas, opcoes]
  );

  const temContasResultado = useMemo(
    () => (opcoes || []).some((o) => Boolean(o.contaResultado)),
    [opcoes]
  );

  useEffect(() => {
    if (!aberto) return undefined;
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setAberto(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [aberto]);

  return (
    <div className={styles.filtroMsDropdown} ref={wrapRef}>
      <button
        type="button"
        className={styles.filtroMsTrigger}
        aria-haspopup="listbox"
        aria-expanded={aberto}
        onClick={() => setAberto((v) => !v)}
      >
        <span className={styles.filtroMsTriggerText}>{textoTrigger}</span>
        <span className={`${styles.filtroMsChevron} ${aberto ? styles.filtroMsChevronOpen : ""}`}>
          ▼
        </span>
      </button>
      {aberto && (
        <div className={styles.filtroMsPanel} role="listbox" aria-label="Conta contábil">
          {opcoes.length > 8 && (
            <input
              type="search"
              className={styles.filtroMsSearch}
              placeholder="Buscar conta…"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              aria-label="Buscar na lista de contas"
            />
          )}
          <div className={styles.filtroMsActions}>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              onClick={() => onChange(acaoSelecionarTodas(opcoes))}
            >
              Selecionar todas
            </button>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              title="Selecionar todas as contas de resultado"
              disabled={!temContasResultado}
              onClick={() => onChange(acaoSelecionarContasResultado(opcoes))}
            >
              Contas de resultado
            </button>
            <button
              type="button"
              className={styles.filtroMsActionBtn}
              onClick={() => {
                onChange(acaoLimparContas());
                setBusca("");
              }}
            >
              Limpar
            </button>
          </div>
          <div className={styles.filtroMsList}>
            {opcoesFiltradas.length === 0 ? (
              <p className={styles.filtroMsEmpty}>Nenhuma conta encontrada.</p>
            ) : (
              opcoesFiltradas.map((c) => (
                <label key={c.codigo} className={styles.filtroMsOption} title={c.label}>
                  <input
                    type="checkbox"
                    checked={isContaMarcada(c.codigo, selecionadas)}
                    onChange={() => onChange(alternarContaSelecao(c.codigo, selecionadas))}
                  />
                  <span className={styles.filtroMsOptionLabel}>
                    {c.label}
                    {c.contaResultado ? (
                      <span
                        className={styles.filtroMsBadgeResultado}
                        title="Conta de Resultado (ECD)"
                      >
                        Resultado
                      </span>
                    ) : null}
                  </span>
                </label>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
